import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Row } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

const Insta = () => {
  return (
    <section className="insta-section">
      <Container className="showcase-container">
        <Row>
          <Col sm={12} md={12} lg={12}>
            <Heading className="text-md-left text-lg-left text-sm-center text-center">
              <h2 className="text-white">Get a Tour of our Social Media</h2>
              <p className="text-white">
                Follow us on Instagram{" "}
                {/* Follow @Khan on Instagram to get inspired */}
                <a
                  href="https://www.instagram.com/p/DJgzOo0vtbT/"
                  className="text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  <strong>@khan_diamonds</strong>
                </a>
              </p>
            </Heading>
            <InstaIframe />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Insta;
